module.exports = __webpack_public_path__ + "static/media/logos.cbef6d67.png";